export default "__VITE_ASSET__11b77283__"